import {
  TOGGLE_CLICKSIGN_VISIBLE,
  CHANGE_CONFIG
} from './actions'

export default function(state = {
  visible: false,
  config: {
    key: '',
    signer: {}
  }
}, action) {
  switch(action.type) {
    case TOGGLE_CLICKSIGN_VISIBLE:
      return { ...state, visible: state.visible ? false : true }
    case CHANGE_CONFIG:
      return { ...state, config: action.payload }
    default:
      return state
  }
}
